import React from 'react';

/**
 * The agent's avatar: a glossy violet orb. Static at rest; while the agent
 * works, its plasma swirls and a halo breathes around it (styles in chat.css).
 */
const AgentOrb = ({ thinking = false, size = 26 }) => (
  <span
    className={`q-agent-orb${thinking ? ' q-agent-orb--thinking' : ''}`}
    style={{ width: size, height: size }}
    aria-hidden="true"
  >
    <span className="q-agent-orb__halo" />
    <span className="q-agent-orb__ring" />
    <span className="q-agent-orb__core">
      <span className="q-agent-orb__swirl" />
      <span className="q-agent-orb__blob q-agent-orb__blob--a" />
      <span className="q-agent-orb__blob q-agent-orb__blob--b" />
      <span className="q-agent-orb__gloss" />
    </span>
  </span>
);

export default AgentOrb;
